export interface EnvironmentData extends ParentMessage {
  parentId?: string;
  production: boolean;
  hyperspaceOnboarding?: string;
  hyperspacePortal?: string;
  stage?: string;
  matomoApplicationId?: number;
  matomoUrl?: string;
  matomoInit?: boolean;
  gcpStorageBaseUrl?: string;
  deliveryProcessingStatus?: DeliveryProcessingStatus;
  jiraDataCenterUrl: string;
  jiraFieldMappings?: JiraFieldMappings;
}

export interface JiraFieldMappings {
  traceabilityRelevant: string;
  manualTestStatus: string;
  xrayTestStatuses: string;
  issueTypeXrayTest: string;
  issueTypeMicrodelivery: string;
}

export enum DeliveryProcessingStatus {
  NEW = 'New',
  ACTIVE = 'Active',
  FINISHED = 'Finished',
}

export interface ParentMessage {
  baseUrl: string;
  deliveryGuid: string;
  readOnly: boolean;
  deliveryName: string;
  isLocked: boolean;
  activationDate: Date;
}
